"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleContent = void 0;
var React = require("react");
var styles_1 = require("@/pages/articleDetail/components/ArticleContent/styles");
var recompose_1 = require("recompose");
var htmlUtils_1 = require("@/utils/htmlUtils");
var Component = function (_a) {
    var newsArticleDetail = _a.newsArticleDetail;
    var data = newsArticleDetail.data;
    var content = data.content;
    // Preprocess the HTML content
    var processedContent = htmlUtils_1.preprocessHtmlContent(content);
    return (React.createElement(styles_1.Container, null,
        React.createElement(styles_1.ContentHTML, null, processedContent)));
};
var enhance = recompose_1.compose(recompose_1.lifecycle({
    componentDidMount: function () {
        var contentElement = document.getElementById('content');
        var imgElements = contentElement.getElementsByTagName('img');
        var imgList = Array.prototype.slice.call(imgElements);
        imgList.forEach(function (element) { return (element.style = ''); });
        var videoElements = contentElement.getElementsByTagName('video');
        var videoList = Array.prototype.slice.call(videoElements);
        videoList.forEach(function (element) { return (element.style = ''); });
        var tableElements = contentElement.getElementsByTagName('table');
        var tableList = Array.prototype.slice.call(tableElements);
        tableList.forEach(function (element) { return (element.style = ''); });
    },
}));
exports.ArticleContent = enhance(Component);
